<ul class="list-unstyled p-unselectable-text {{loco?.isGrayed ? 'disabled-loco' : ''}}" id="selection{{loco?.locomotiveIdentifier}}" (click)='locomotiveSelection($event, loco);' *ngIf="!isEditable">
    <li class="{{trainEdit?.dragMode ? 'train-loco-image train-dragMode' : 'train-loco-image'}} ">
        <span *ngIf='trainEdit?.dragMode'>{{loco?.originalSequence}}</span>
        <div id="loco{{loco?.locomotiveIdentifier}}" (contextmenu)='$event.preventDefault(); showLocoContextMenu(loco);' [ngClass]="loco && loco.isLocated ? 'train-page-svg locate-highlight' :'train-page-svg'">
            <lms-loco-svg [loco]="loco" [trainData]='trainData' [svgWidthClass]="'traindata-loco-svg'">
            </lms-loco-svg>
        </div>
    </li>
    <li>{{loco?.consistSequence ? (loco?.consistSequence === "P" ? 'Planned' : loco?.consistSequence) : '-'}}</li>
    <li class="intended-data-column"><span class="{{trainLocoIntendedUsageCode === 'NP' ? 'color-red':''}}">{{trainLocoIntendedUsageValue}}</span>
        <span class="train-loco-intended-reason" *ngIf="trainLocoIntendedUsageReason"><br/>{{trainLocoIntendedUsageReason}}</span>
        <span class="train-loco-intended-notes" *ngIf="trainLocointendedUsageNote"><br/>{{trainLocointendedUsageNote}}</span>
    </li>
    <li>{{loco?.problemCodes? loco?.problemCodes : '-'}}</li>
    <li>{{loco?.lastFueledLocation? loco?.lastFueledLocation : '-'}}</li>
    <li>{{loco?.lastFueledDate ? loco?.lastFueledDate : '-'}}</li>
    <li>{{loco?.miles? loco?.miles : '-'}}</li>
    <li>{{loco?.locoForm ? loco?.locoForm : '-'}}</li>
    <li class="notes-column">
        <p>{{loco?.noteText ? loco?.noteText : '-' }}</p>
    </li>
    <li>{{loco?.remarks ? loco?.remarks : '-'}}</li>
    <li>{{(loco?.deadIsolatedFlag && loco?.deadIsolatedFlag === 'F') ? 'Dead' : (loco?.deadIsolatedFlag && loco?.deadIsolatedFlag === 'Z') ? 'Isolated' : 
        (loco?.deadIsolatedFlag === '' || loco?.deadIsolatedFlag === ' ') ? 'Running' : 'Unknown'}}</li>
    <li>{{loco?.permanentTag ? loco?.permanentTag : (loco?.locoTag ? loco?.locoTag : '-')}}</li>
    <li>{{(loco?.directionFacing && loco?.directionFacing === 'F') ? 'Forward' : (loco?.directionFacing && loco?.directionFacing === 'B') ? 'Backward' : 'Unknown'}}</li>
    <li>{{loco?.clazz? loco?.clazz : '-'}}</li>
    <li>{{loco?.tractiveEffort ? loco?.tractiveEffort : '-'}}</li>
    <li>{{loco?.horsePower ? loco?.horsePower : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentAssign) ? ((loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "P") ? loco?.plannedOrCurrentAssign : '-') : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentLoc) && (loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "P") ? loco?.plannedOrCurrentLoc : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentAssign) ? ((loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "A") ? plannedAssignmentValue : '-') : '-'}}</li>
    <li>{{loco?.plannedPickUpLocation ? loco?.plannedPickUpLocation : '-'}}</li>
</ul>

<ul class="list-unstyled p-unselectable-text train-editable editable-fields" id="selection{{loco?.locomotiveIdentifier}}" (click)='locomotiveSelection($event, loco);' *ngIf="isEditable" [formGroup]='locoForm'>
    <li class="train-loco-image">
        <!--<span *ngIf='trainEdit?.dragMode'>{{loco?.originalSequence}}</span>-->
        <div id="loco{{loco?.locomotiveIdentifier}}" [ngClass]="loco && loco.isLocated ?'train-page-svg locate-highlight' :'train-page-svg'">
            <lms-loco-svg [loco]="loco" [svgWidthClass]="'traindata-loco-svg'" [trainData]='trainData' (contextmenu)='$event.preventDefault(); showLocoContextMenu(loco);'>
            </lms-loco-svg>
        </div>
    </li>
    <li>{{loco?.consistSequence}}</li>
    <li class="intended-data-column"><span class="{{trainLocoIntendedUsageCode === 'NP' ? 'color-red':''}}">{{trainLocoIntendedUsageValue}}</span>
        <span class="train-loco-intended-reason" *ngIf="trainLocoIntendedUsageReason"><br/>{{trainLocoIntendedUsageReason}}</span>
        <span class="train-loco-intended-notes" *ngIf="trainLocointendedUsageNote"><br/>{{trainLocointendedUsageNote}}</span>
    </li>
    <li>{{loco?.problemCodes? loco?.problemCodes : '-'}}</li>
    <!--<li *ngIf='!isEditable'>{{loco?.lastFueledLocation? loco?.lastFueledLocation : '-'}}</li>-->
    <li>
        <input id='{{"firstElem" + loco?.locomotiveIdentifier}}' spellcheck="false" class="{{('C' ===locoError?.fuelStationError ||'H' ===locoError?.fuelStationError)?'train-edit-mode p-inputfield p-inputfield-error':'train-edit-mode p-inputfield'}}" type="text"
            maxlength="6" formControlName="fuelLocation" tabindex="{{tabIndexes + 0}}" style="text-transform: uppercase;">
    </li>
    <li>
        <lms-lms-calender styleClass="{{('C' ===locoError?.fuelMMDDError ||'H' ===locoError?.fuelMMDDError)?'train-edit-mode p-calendar p-inputfield-error':'train-edit-mode p-calendar'}}" [minDate]='minDateValue' formControlName='fuelDate' [showIcon]="true"
            dataType="string" [maxDate]='maxDateValue' dateFormat='mm/dd/yy' tabindex="{{tabIndexes + 1}}" [readonlyInput]="true"></lms-lms-calender>
    </li>
    <li>
        <input spellcheck="false" tabindex="{{tabIndexes +2}}" class="{{('C' ===locoError?.milesError ||'H' ===locoError?.milesError)?'train-edit-mode p-inputfield p-inputfield-error':'train-edit-mode p-inputfield'}}" type="text" maxlength="4" formControlName="miles"
            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57">
    </li>
    <li>{{loco?.locoForm ? loco?.locoForm : '-'}}</li>
    <li class="notes-column">
        <p>{{loco?.noteText ? loco?.noteText : '-' }}</p>
    </li>
    <li>
        <input tabindex="{{tabIndexes + 3}}" type="text" class="train-edit-mode p-inputfield" maxlength="15" formControlName="remarks" style="text-transform: uppercase;" />
    </li>
    <li>
        <p-dropdown [options]="deadIsolatedDropdown" [tabindex]="tabIndexes + 4" formControlName="deadIso" styleClass="{{('C' ===locoError?.deadIsolatedError ||'H' ===locoError?.deadIsolatedError) ? 'p-inputfield-error train-edit-mode pull-left' : 'train-edit-mode pull-left'}}">
            <ng-template let-flag>
                <div class="p-helper-clearfix ">
                    <div> {{flag?.label}} </div>
                </div>
            </ng-template>
        </p-dropdown>
    </li>
    <li>{{loco?.permanentTag ? loco?.permanentTag : (loco?.locoTag ? loco?.locoTag : '-')}}</li>
    <li>
        <p-dropdown [options]="directionDropdown" [tabindex]="tabIndexes + 5" formControlName="direction" styleClass="{{('C' ===locoError?.directionFacingError ||'H' ===locoError?.directionFacingError) ? 'train-edit-mode p-inputfield-error pull-left' : 'train-edit-mode pull-left'}}">
            <ng-template let-direction>
                <div class="p-helper-clearfix ">
                    <div> {{direction?.label}} </div>
                </div>
            </ng-template>
        </p-dropdown>
    </li>
    <li>{{loco?.clazz? loco?.clazz : '-'}}</li>
    <li>{{loco?.tractiveEffort ? loco?.tractiveEffort : '-'}}</li>
    <li>{{loco?.horsePower ? loco?.horsePower : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentAssign) ? ((loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "P") ? loco?.plannedOrCurrentAssign : '-') : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentLoc) && (loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "P") ? loco?.plannedOrCurrentLoc : '-'}}</li>
    <li>{{(loco?.plannedOrCurrentAssign) ? ((loco?.assignedPlannedFlag && loco?.assignedPlannedFlag === "A") ? plannedAssignmentValue : '-') : '-'}}</li>
    <li>{{loco?.plannedPickUpLocation ? loco?.plannedPickUpLocation : '-'}}</li>
</ul>